import { roundups } from '@/mocks/homeContent';

export default function RoundupGrid() {
  return (
    <section id="library" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-10 flex flex-col gap-4 md:mb-14 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-primary-600">
              <span className="h-px w-8 bg-primary-500"></span> Content Archive
            </span>
            <h2 className="mt-3 font-display text-3xl font-black text-foreground-950 md:text-4xl">
              精选内容大全 <span className="text-primary-600">·</span> 一页收齐
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-foreground-600">
            按题材归类整理的大全目录：想看哪条线，点封面直接进入对应的专题合集。
          </p>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {roundups.map((r, i) => (
            <a
              key={r.title}
              href="#digest"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-shadow hover:shadow-lg cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden sm:h-48">
                <img
                  src={r.image}
                  alt={r.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 to-transparent"></div>
                <span
                  className={`absolute left-3 top-3 inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold text-background-50 whitespace-nowrap ${
                    i % 3 === 0
                      ? 'bg-primary-500'
                      : i % 3 === 1
                        ? 'bg-accent-500'
                        : 'bg-secondary-500'
                  }`}
                >
                  <i className="ri-hashtag text-xs"></i>
                  {r.tag}
                </span>
                <span className="absolute bottom-3 right-3 inline-flex h-8 w-8 items-center justify-center rounded-full bg-background-50/90 text-foreground-800 opacity-0 transition-all group-hover:opacity-100">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-display text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {r.title}
                </h3>
                <p className="mt-2 flex-1 text-[13px] leading-relaxed text-foreground-600">{r.desc}</p>
                <div className="mt-4 flex items-center gap-2 border-t border-background-100 pt-3 text-[11px] text-foreground-500">
                  <span className="inline-flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-fire-line text-primary-500"></i>
                    热度集中
                  </span>
                  <span className="h-1 w-1 rounded-full bg-foreground-300"></span>
                  <span className="whitespace-nowrap">持续更新中</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}